import React from 'react';
import {createPortal} from "react-dom";
import './PolToaster.scss';

export default function PolToaster({portalRootSelector = 'body', children}) {
    return (
        createPortal(
            <div className="pol-toaster">
                {children}
            </div>,
            document.querySelector(portalRootSelector) ?? document.body
        )
    )
}
